import { TbBuilding, TbNut } from "react-icons/tb";

import { CommonStatusItem, PassengerTypes } from "@/types/global";

import { softColors } from "./colors";

export type PassengerTypeItem = CommonStatusItem & {
    label: string;
    value: PassengerTypes;
};

export type PassengerTypeList = PassengerTypeItem[];

export const passengerTypes: PassengerTypeList = [
    {
        label: "Klinik",
        value: PassengerTypes.KLINIK,
        component: () => TbBuilding,
        ...softColors.green,
        tooltip: {
            title: "Klinik Yolcusu",
            description: "Yolcu klinik yolcusu olarak otomatik olarak sisteme eklenmiştir.",
        },
    },
    {
        label: "Manuel",
        value: PassengerTypes.MANUAL,
        component: () => TbNut,
        ...softColors.indigo,
        tooltip: {
            title: "Manuel Yolcu",
            description: "Yolcu transport ekibi tarafından sisteme eklenmiştir.",
        },
    },
];
